import { handleActions } from 'redux-actions';
import { Actions } from 'actions/apiActions';
import { merge, omit } from 'lodash';
import { ApiCall } from 'shared/models';

export type State = {
    calls: {
        [seq: string]: ApiCall;
    };
    pending: {
        [seq: string]: boolean;
    };
};

export const initialState = Object.freeze<State>({
    calls: {},
    pending: {},
});

export const apiReducer = handleActions({
    [Actions.CALL_STARTING]: (state, action: any) => {
        const { method, endpoint, seq, when } = action.payload;
        return merge({}, state, {
            calls: {
                [`${seq}`]: { method, endpoint, when, seq },
            },
            pending: {
                [`${seq}`]: true,
            },
        });
    },
    [Actions.CALL_FINISHED]: (state, action: any) => {
        const { seq /*, when */ } = action.payload;
        // TODO: could use when to monitor call durations
        return {
            ...state,
            pending: omit(state.pending, `${seq}`),
        };
    },
}, initialState);
